const addDash = (url) => {
  if (!url || typeof url !== 'string') return null
  return url.endsWith('/') ? url : `${url}/`
}

export { addDash }
